import dyslexiaIcon from '../../icons/dyslexiaIcon.svg'
import volumeUpIcon from '../../icons/volumeUpIcon.svg'

export default [
  {
    label: 'Dyslexia Font',
    key: 'readable-font',
    icon: dyslexiaIcon,
  },
  {
    label: 'Screen Reader',
    key: 'screen-reader',
    icon: volumeUpIcon,
  },
]
